import React, { FC } from "react";
import { Button } from "components/shared";
import { BUTTON_VARIANTS, BUTTON_COLORS } from "components/shared/Button/Button";
import styles from "./DeletingLine.module.sass";

interface DeletingLineProps {
	close: () => void;
	closeAll: () => void;
	toDelete: () => void;
	title: string;
}

export const DeletingLine: FC<DeletingLineProps> = ({ close, closeAll, title, toDelete }) => {
	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
	};

	const deletingHandler = () => {
		toDelete();
		closeAll();
	};

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>{title}</h4>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отмена
					</Button>
					<Button onClick={deletingHandler} color={BUTTON_COLORS.ERROR} type="submit" className={styles.button}>
						Удалить
					</Button>
				</div>
			</form>
		</section>
	);
};
